module.exports = __webpack_public_path__ + "static/media/globe_blue.139ffc35.svg";